/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierAdvancedLtiEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_ADVANCED_LTI_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierAdvancedLtiEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierAdvancedLtiEnabledSettingParser.decode(input).map(res => new TierAdvancedLtiEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierAdvancedLtiEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierAdvancedLtiEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierAdvancedLtiEnabledSettingParser.schema();
    }
}
